import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export default function NoPrimaryCampusModal({ show, onClose }) {
  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Primary Campus Required</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        Your account does not have a primary campus assigned. Please contact your
        system administrator to assign you to a primary campus before using the
        Report Incident panel.
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={onClose}>
          Back to Login
        </Button>
      </Modal.Footer>
    </Modal>
  );
}